import { CARRIER_POSTAL_CODE_MATCH_KIND, CARRIER_TEXT_MATCH_KIND, PENNYLANE_ORIGIN } from '../status/carrier.js';
function originLabel(code, options) {
    if (code === PENNYLANE_ORIGIN) {
        return 'Pennylane';
    }
    return options.originName?.(code) ?? code.toUpperCase();
}
/**
 * Résumé lisible des conditions d'une règle transporteur — la colonne
 * « Conditions » de l'écran Transporteurs (`02` §9) et l'infobulle du
 * simulateur. Une règle sans aucune contrainte affiche « Toutes les
 * commandes » plutôt qu'une chaîne vide.
 *
 * Vit dans `@flux/shared` parce que serveur (messages d'avertissement) et
 * interface (tableau) doivent en dire exactement la même chose.
 */
export function summarizeCarrierConditions(conditions, options = {}) {
    const parts = [];
    if (conditions.origins.length > 0) {
        parts.push(`Origine ${conditions.origins.map((code) => originLabel(code, options)).join(', ')}`);
    }
    if (conditions.shippingMethod !== null) {
        const kind = CARRIER_TEXT_MATCH_KIND[conditions.shippingMethod.match].label.toLowerCase();
        const operator = conditions.shippingMethod.match === 'exact' ? '=' : kind;
        parts.push(`Mode ${operator} ${conditions.shippingMethod.value}`);
    }
    if (conditions.countries.length > 0) {
        parts.push(`Pays ${conditions.countries.join(', ')}`);
    }
    if (conditions.postalCode !== null) {
        const kind = CARRIER_POSTAL_CODE_MATCH_KIND[conditions.postalCode.match].label.toLowerCase();
        parts.push(`CP ${kind} ${conditions.postalCode.value}`);
    }
    if (conditions.channels.length > 0) {
        parts.push(`Canal ${conditions.channels.join(', ')}`);
    }
    return parts.length === 0 ? 'Toutes les commandes' : parts.join(' · ');
}
//# sourceMappingURL=conditions-summary.js.map